var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "conversations" }, [
    _c(
      "a",
      {
        staticClass: "logo",
        attrs: {
          href: _vm.downloadLink,
          "data-clipboard-text": this.$store.state.chat.code,
        },
        on: { click: _vm.logoDownloadEvent },
      },
      [_c("img", { attrs: { src: "/public/logo_v2.png" } })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "door" }, [
      _c("img", { attrs: { src: "/public/Door@3x.png" } }),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.conversations.conversation.title))]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          _vm._s(_vm.conversations.conversation.participantCount) + " joined"
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "join" }, [
      _c("img", {
        staticClass: "triangle",
        attrs: { src: "/public/Triangle@2x.png" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "slogen",
        attrs: { src: "/public/chat_with_frient_us@2x.png" },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn-join",
          attrs: { href: _vm.downloadLink },
          on: { click: _vm.buttonDownloadEvent },
        },
        [_c("img", { attrs: { src: "/public/join_room@2x.png" } })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "box-copy", on: { click: _vm.copyEvent } }, [
        _vm._v("\n      Room code"),
        _c("b", [
          _vm._v(_vm._s(_vm.conversations.conversation.webCode.toUpperCase())),
        ]),
        _c(
          "button",
          {
            staticClass: "copy",
            attrs: {
              id: "btn_copy",
              "data-clipboard-action": "copy",
              "data-clipboard-target": "#copy_text",
            },
          },
          [_vm._v("\n        Copy\n      ")]
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        staticStyle: { opacity: "0" },
        attrs: { id: "copy_text", type: "text", readonly: "" },
        domProps: { value: _vm.copyWebCodeValue },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/Conversations.vue